import React from "react";
import ComplexMenuBar from "../Complex";
import GivingDayMenuBar from "../GivingDay";

const components = {
  complex: ComplexMenuBar,
  giving_day: GivingDayMenuBar,
};

export default function MenuBar(props) {
  const {
    menu: { menu_type },
  } = props;

  const MenuBarComponent = components[menu_type];

  return <MenuBarComponent {...props} />;
}
